<template>
  <div>
    <LineOaButton />
  </div>
</template>

<script>
import LineOaButton from "@/components/Page/Liff/LineOaButton.vue";

export default {
  components: { LineOaButton },
}
</script> 